import type { CSSProperties } from 'react'
import type { ButtonSize, ButtonVariant } from './Button.types.ts'

const VARIANT_STYLES: Record<ButtonVariant, CSSProperties> = {
  primary: {
    background: 'var(--gradient-brand)',
    color: 'var(--color-text-inverse)',
    border: 'none',
    boxShadow: 'var(--shadow-glow)',
  },
  secondary: {
    background: 'var(--color-secondary)',
    color: 'var(--color-text-inverse)',
    border: 'none',
  },
  outline: {
    background: 'transparent',
    color: 'var(--color-text-primary)',
    border: '1px solid var(--color-border)',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--color-text-secondary)',
    border: 'none',
  },
}

const SIZE_STYLES: Record<ButtonSize, CSSProperties> = {
  sm: { padding: '0.375rem 0.75rem', fontSize: '0.8125rem' },
  md: { padding: '0.5rem 1rem', fontSize: '0.875rem' },
  lg: { padding: '0.75rem 1.5rem', fontSize: '1rem' },
}

export function getButtonStyle(
  variant: ButtonVariant,
  size: ButtonSize,
  disabled?: boolean,
): CSSProperties {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    borderRadius: 'var(--radius-md)',
    fontWeight: 600,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all var(--transition-fast)',
    opacity: disabled ? 0.6 : 1,
    ...VARIANT_STYLES[variant],
    ...SIZE_STYLES[size],
  }
}
